export default {
  'lv0':[{
    text:'Aa',
    spot:'a',
    path:'/static/voice/a.mp3'
  },{
    text:'Bb',
    spot:'b',
    path:'/static/voice/b.mp3'
  },{
    text:'Cc',
    spot:'c',
    path:'/static/voice/c.mp3'
  },{
    text:'Dd',
    spot:'d',
    path:'/static/voice/d.mp3'
  },{
    text:'Ee',
    spot:'e',
    path:'/static/voice/e.mp3'
  },{
    text:'Ff',
    spot:'f',
    path:'/static/voice/f.mp3'
  },{
    text:'Gg',
    spot:'g',
    path:'/static/voice/g.mp3'
  },{
    text:'Hh',
    spot:'h',
    path:'/static/voice/h.mp3'
  },{
    text:'Ii',
    spot:'i',
    path:'/static/voice/i.mp3'
  },{
    text:'Jj',
    spot:'j',
    path:'/static/voice/j.mp3'
  },{
    text:'Kk',
    spot:'k',
    path:'/static/voice/k.mp3'
  },{
    text:'Ll',
    spot:'l',
    path:'/static/voice/l.mp3'
  },{
    text:'Mm',
    spot:'m',
    path:'/static/voice/m.mp3'
  },{
    text:'Nn',
    spot:'n',
    path:'/static/voice/n.mp3'
  },{
    text:'Oo',
    spot:'o',
    path:'/static/voice/o.mp3'
  },{
    text:'Pp',
    spot:'p',
    path:'/static/voice/p.mp3'
  },{
    text:'Qq',
    spot:'q',
    path:'/static/voice/q.mp3'
  },{
    text:'Rr',
    spot:'r',
    path:'/static/voice/r.mp3'
  },{
    text:'Ss',
    spot:'s',
    path:'/static/voice/s.mp3'
  },{
    text:'Tt',
    spot:'t',
    path:'/static/voice/r.mp3'
  },{
    text:'Uu',
    spot:'u',
    path:'/static/voice/u.mp3'
  },{
    text:'Vv',
    spot:'v',
    path:'/static/voice/v.mp3'
  },{
    text:'Ww',
    spot:'w',
    path:'/static/voice/w.mp3'
  },{
    text:'Xx',
    spot:'x',
    path:'/static/voice/x.mp3'
  },{
    text:'Yy',
    spot:'y',
    path:'/static/voice/y.mp3'
  },{
    text:'Zz',
    spot:'z',
    path:'/static/voice/z.mp3'
  },],

  'lv1':[{
    pic:'/static/images/ceshiti/prereading/1.png',
    spot:'pirate',
  },{
    pic:'/static/images/ceshiti/prereading/2.png',
    spot:'grapes',
  },{
    pic:'/static/images/ceshiti/prereading/3.png',
    spot:'strawberries',
  },{
    pic:'/static/images/ceshiti/prereading/4.png',
    spot:'hole',
  },{
    pic:'/static/images/ceshiti/prereading/5.png',
    spot:'nest',
  },{
    pic:'/static/images/ceshiti/prereading/6.png',
    spot:'piano',
  },{
    pic:'/static/images/ceshiti/prereading/7.png',
    spot:'drum',
  },{
    pic:'/static/images/ceshiti/prereading/8.png',
    spot:'bath',
  },{
    pic:'/static/images/ceshiti/prereading/9.png',
    spot:'socks',
  },{
    pic:'/static/images/ceshiti/prereading/10.png',
    spot:'rooster',
  },{
    pic:'/static/images/ceshiti/prereading/11.png',
    spot:'pig',
  },{
    pic:'/static/images/ceshiti/prereading/12.png',
    spot:'pull',
  },{
    pic:'/static/images/ceshiti/prereading/13.png',
    spot:'skip',
  },{
    pic:'/static/images/ceshiti/prereading/14.png',
    spot:'vegetables',
  },{
    pic:'/static/images/ceshiti/prereading/15.png',
    spot:'seeds',
  },{
    pic:'/static/images/ceshiti/prereading/16.png',
    spot:'flower',
  },{
    pic:'/static/images/ceshiti/prereading/17.png',
    spot:'octopus',
  },{
    pic:'/static/images/ceshiti/prereading/18.png',
    spot:'dolphin',
  },{
    pic:'/static/images/ceshiti/prereading/19.png',
    spot:'tiger',
  },{
    pic:'/static/images/ceshiti/prereading/20.png',
    spot:'fish',
  },{
    pic:'/static/images/ceshiti/prereading/21.png',
    spot:'plane',
  },{
    pic:'/static/images/ceshiti/prereading/22.png',
    spot:'train',
  },{
    pic:'/static/images/ceshiti/prereading/23.png',
    spot:'bird',
  },{
    pic:'/static/images/ceshiti/prereading/24.png',
    spot:'kitten',
  },]
}



// WEBPACK FOOTER //
// ./src/testdata/speak.js